module.exports = __webpack_public_path__ + "static/media/provider-booklet.53a7f482.png";